module.exports = __webpack_public_path__ + "static/media/pencil.6ec9e5a1.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons/pencil.svg
 ** module id = 437
 ** module chunks = 0
 **/